import pbgClient from './client'
import type {
  AgentCarrierIdentifierCreateRequest,
  AgentCarrierIdentifierResponse,
  AgentCarrierIdentifierUpdateRequest,
  AgentCreateRequest,
  AgentGetResponse,
  AgentsListResponse,
  AgentStateLicenseCreateRequest,
  AgentStateLicenseResponse,
  AgentStateLicenseUpdateRequest,
  AgentUpdateRequest,
} from './ideon-agents.types'

const BASE = '/api/v1/benefit-integrations/ideon/agents'

export const listIdeonAgents = (
  params: { page?: number; perPage?: number } = {}
) => pbgClient.get<AgentsListResponse>(BASE, { params }).then((r) => r.data)

export const createIdeonAgent = (body: AgentCreateRequest) =>
  pbgClient.post<AgentGetResponse>(BASE, body).then((r) => r.data)

export const getIdeonAgent = (agentId: string) =>
  pbgClient.get<AgentGetResponse>(`${BASE}/${agentId}`).then((r) => r.data)

export const updateIdeonAgent = (agentId: string, body: AgentUpdateRequest) =>
  pbgClient
    .put<AgentGetResponse>(`${BASE}/${agentId}`, body)
    .then((r) => r.data)

export const createIdeonAgentStateLicense = (
  agentId: string,
  body: AgentStateLicenseCreateRequest
) =>
  pbgClient
    .post<AgentStateLicenseResponse>(`${BASE}/${agentId}/state-licenses`, body)
    .then((r) => r.data)

export const updateIdeonAgentStateLicense = (
  agentId: string,
  licenseId: string,
  body: AgentStateLicenseUpdateRequest
) =>
  pbgClient
    .put<AgentStateLicenseResponse>(
      `${BASE}/${agentId}/state-licenses/${licenseId}`,
      body
    )
    .then((r) => r.data)

export const deleteIdeonAgentStateLicense = (
  agentId: string,
  licenseId: string
) => pbgClient.delete(`${BASE}/${agentId}/state-licenses/${licenseId}`)

export const createIdeonAgentCarrierIdentifier = (
  agentId: string,
  body: AgentCarrierIdentifierCreateRequest
) =>
  pbgClient
    .post<AgentCarrierIdentifierResponse>(
      `${BASE}/${agentId}/carrier-identifiers`,
      body
    )
    .then((r) => r.data)

export const updateIdeonAgentCarrierIdentifier = (
  agentId: string,
  carrierIdentifierId: string,
  body: AgentCarrierIdentifierUpdateRequest
) =>
  pbgClient
    .put<AgentCarrierIdentifierResponse>(
      `${BASE}/${agentId}/carrier-identifiers/${carrierIdentifierId}`,
      body
    )
    .then((r) => r.data)

export const deleteIdeonAgentCarrierIdentifier = (
  agentId: string,
  carrierIdentifierId: string
) =>
  pbgClient.delete(
    `${BASE}/${agentId}/carrier-identifiers/${carrierIdentifierId}`
  )
